<template>
  <div class="soc_back_videos">
    <!-- <div class="back_mark" v-if="isDownload"></div> -->
    <div
      class="video_cursor"
      :style="{ left: cursorLeft + 'px', opacity: cursorOpacity }"
    >
      <div class="video_cursor_content">
        <span class="time_format">
          {{ formatCursorTime }}
        </span>
      </div>
    </div>
    <div class="back_camera_item">
      <div class="camera_title nor">
        <i
          class="iconfont icon-jian"
          @click="handleChangeViewMin"
          :title="$t('video.label.reduceScale')"
        ></i>
        <soc-bar
          side-id="video-b-side"
          active-color="#535F7D"
          :is-show-tips="true"
          :format-tooltip="formatTooltip"
          v-model="scale"
          @change="handleChangeView"
        ></soc-bar>
        <i
          class="iconfont icon-jia"
          @click="handleChangeViewPlus"
          :title="$t('video.label.enlargeScale')"
        ></i>
      </div>
      <div style="width: 130px">
        <el-time-picker
          v-model="checkedTime"
          style="width: 130px"
          @change="checkClick"
          value-format="HH:mm:ss"
          :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
          placeholder="自定义时间"
        >
        </el-time-picker>
      </div>
      <div
        class="camera_back_data"
        :style="videosData.length > 3 ? 'padding-right:65px' : ''"
      >
        <div class="scale_container" id="scaleWidth">
          <div
            v-for="(item, index) in scaleNum"
            :key="index"
            :class="['scale_un', item % labelInterVal === 0 ? 'ps' : '']"
          >
            <!--{{item}}-->
            <template v-if="item === 1">
              <div class="label">{{ formatDate(0) }}</div>
            </template>
            <template v-if="item % labelInterVal === 0">
              <div class="label">
                {{ formatScaleTime(item) }}
              </div>
            </template>
          </div>
          <!-- <template v-for="item in scaleNum">
          </template> -->
        </div>
      </div>
    </div>
    <!-- {{ videosData }} -->
    <div class="list_content_container">
      <div
        :class="[
          'back_camera_item',
          activeWindow === key ? 'active' : '',
          downloadActive === key ? 'download' : '',
        ]"
        v-for="(camera, key) in videosData"
        @click="handleClickActive(key)"
        :key="key"
      >
        <div class="camera_title noresize" :title="camera.name">
          {{ $t("video.label.windows") }}{{ key }}：{{ camera.name }}
        </div>

        <div class="camera_back_data" style="padding: 0 35px 0 157px">
          <div
            class="data_content"
            @dblclick="handleClickPlay($event, key, camera)"
            @mouseover="handleMouseHover($event, key)"
            @mousemove="handleMouseHover($event, key)"
            @mouseleave="handleMouseLeave"
          >
            <div
              class="cursor_div"
              :style="{
                left:
                  (activeWindow === key
                    ? getCurLeft
                    : handleVideoProgress(key)) + 'px',
              }"
            >
              <i class="el-icon-caret-bottom"></i>
            </div>
            <div :class="['video_data_list']"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SocBar from "./soc-bar";
import DayJs from "dayjs";

export default {
  name: "back-videos",
  components: { SocBar },
  props: {
    startTime: {
      type: Number,
      default: 0,
    },
    endTime: {
      type: Number,
      default: 0,
    },
    videosData: {
      type: Array,
      default: () => [],
    },
    //    videosData: {
    //   type: String,
    //   default: () => null,
    // },
    left: {
      type: String,
      default: null,
    },
    width: {
      type: String,
      default: null,
    },
    playTime: {
      type: String,
      default: null,
    },
    wnd: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      // startTime: 0,
      // endTime: 0,
      // videosData: [
      //   {
      //     ability: "0",
      //     cameraType: null,
      //     children: null,
      //     deviceType: "18",
      //     distance: null,
      //     faultCount: null,
      //     id: "20221117216092",
      //     inlineCount: 0,
      //     isLeaf: "0",
      //     latitude: "35.2924920000",
      //     longitude: "118.0440630000",
      //     name: "西安大路街口",
      //     nodeType: "device",
      //     parentId: "200000001",
      //     status: "1",
      //     thirdCameraId: "78-DE-FZ_1",
      //     totalCount: 0,
      //   },
      // ],
      scale: 0,
      scaleNum: 48,
      interval: 2,
      timestamp: this.startTime,
      // timestamp: new Date().getTime(),
      labelInterVal: 4,
      scaleUn: 15,
      scaleLength: 24 * 60 * 60,
      activeWindow: "",
      cursorLeft: -1,
      cursorOpacity: 0,
      moveCall: null,
      cursorValue: 0,
      cLeft: 0,
      mData: {},
      isDrag: false,
      downloadDefault: {
        left: 0,
        width: 0,
      },
      moveValue: 0,
      moveLeft: 0,
      downloadActive: "",
      isBottom: false,
      progressObject: {},
      activeProgress: 0,
      checkedTime: "",
    };
  },
  computed: {
    getScaleWidth() {
      return this.width ? Number(this.width.replace(/px/g, "")) - 135 - 80 : 0;
    },
    getSecWidth() {
      return this.getScaleWidth / this.scaleLength;
    },
    getTimeRangeType() {
      return (this.endTime - this.startTime) / (60 * 60 * 1000);
    },
    getChangeTime() {
      return this.startTime + this.endTime;
    },
    getStartTimeM() {
      return DayJs(this.startTime).format("HH");
    },
    getStartTimeS() {
      return DayJs(this.startTime).format("mm");
    },
    localOffset() {
      let date = new Date();
      return date.getTimezoneOffset() * 60000;
    },
    getLeft() {
      return this.left ? Number(this.left.replace(/px/g, "")) : 0;
    },
    formatCursorTime() {
      let widthAll = "";
      if (document.getElementById("scaleWidth")) {
        widthAll = document.getElementById("scaleWidth").offsetWidth;
      }
      console.log(this.cursorValue, this.scaleLength, widthAll, "====allangth");

      return DayJs(
        this.timestamp + (this.cursorValue * this.scaleLength) / widthAll
      ).format("HH:mm:ss");
      // return DayJs(this.timestamp + this.cursorValue / this.getSecWidth).format('HH:mm:ss')
    },
    getCurLeft() {
      return this.playTime
        ? (this.handleTimeNumber(this.playTime) - this.timestamp) *
            this.getSecWidth
        : 0;
    },
    getDownloadWidth() {
      return this.downloadDefault.width + this.moveValue < 0
        ? 0
        : this.downloadDefault.width + this.moveValue;
    },
    getDownloadLeft() {
      return this.downloadDefault.left + this.moveLeft;
    },
    getDownloadStartTime() {
      return this.timestamp + (this.getDownloadLeft - 32) / this.getSecWidth;
    },
    getDownloadEndTime() {
      return (
        this.getDownloadStartTime + this.getDownloadWidth / this.getSecWidth
      );
    },
    downloadSTime() {
      return DayJs(this.getDownloadStartTime).format("HH:mm:ss");
    },
    downloadETime() {
      return DayJs(this.getDownloadEndTime).format("HH:mm:ss");
    },
  },
  watch: {
    videosData(newVal, oldVal) {
      if (newVal) {
        this.$forceUpdate();
        console.log(newVal, oldVal, "-----VIDEOdATA");
      }
    },
    // videosData: function (newVal) {
    //   this.mData = newVal ? JSON.parse(newVal) : {};
    //   let _arr = newVal ? JSON.parse(newVal) : null;
    //   if (!_arr) {
    //     return;
    //   }
    //   Object.keys(_arr).forEach((key) => {
    //     this.progressObject[key] = "";
    //   });
    //   this.$log.debug("录像查询结果：", _arr);
    //   // console.info('进度监听数据#', JSON.stringify(this.progressObject))
    // },
    playTime: function (newVal) {
      console.log(newVal,'====newVal')
      if (!newVal) {
        return;
      }
      // console.info('播放时间:', newVal + '#窗口信息#:' + this.wnd);
      // console.info('选中窗口:', this.activeWindow);
      this.progressObject[this.wnd] = newVal;
      console.info("选中窗口进度值#:", this.progressObject[this.wnd]);
    },
    scale: function (newVal) {
      console.log(newVal, "====newValscale");
      // 24个小时视图
      if (newVal === 0) {
        this.changeView(48, 15, 4);
        this.scaleLength = 24 * 60 * 60 * 1000;
        this.$log.debug(this.getSecWidth);
        return;
      }
      // 30分钟间隔12小时视图
      if (newVal === 25) {
        this.changeView(24, 15, 4);
        this.scaleLength = 12 * 60 * 60 * 1000;
        this.$log.debug(this.getSecWidth);
        return;
      }
      // 12分钟间隔9小时视图
      if (newVal === 50) {
        this.changeView(30, 9, 5);
        this.scaleLength = 9 * 60 * 60 * 1000;
        this.$log.debug(this.getSecWidth);
        return;
      }
      // 12分钟间隔6小时视图
      if (newVal === 75) {
        this.changeView(30, 6, 3);
        this.scaleLength = 6 * 60 * 60 * 1000;
        this.$log.debug(this.getSecWidth);
        return;
      }
      // 五分钟间隔3小时视图
      if (newVal === 100) {
        this.changeView(36, 2.5, 3);
        this.scaleLength = 3 * 60 * 60 * 1000;
        this.$log.debug(this.getSecWidth);
      }
    },
    getChangeTime: function (val) {
      console.log(">>>>>>>>>>>>>>>>", val, this.getTimeRangeType);
      const type = this.getTimeRangeType;
      const _hour = this.getStartTimeM;
      const _min = this.getStartTimeS;
      // console.log(_hour);
      // console.log(_min);
      if (type > 12 && type <= 24) {
        this.scale = 0;
        // this.timestamp = this.startTime;
        this.handleStartTimeByMax(24);
        this.changeView(48, 15, 4);
        this.scaleLength = 24 * 60 * 60 * 1000;
        return;
      }
      if (type > 9 && type <= 12) {
        this.scale = 25;
        this.handleStartTimeByMax(12);
        this.changeView(24, 15, 4);
        this.scaleLength = 12 * 60 * 60 * 1000;
        return;
      }
      if (type > 6 && type <= 9) {
        this.scale = 50;
        this.timestamp = this.startTime;
        this.changeView(30, 9, 5);
        this.scaleLength = 9 * 60 * 60 * 1000;
        // console.log(this.getSecWidth);
        return;
      }
      if (type > 3 && type <= 6) {
        this.scale = 75;
        this.timestamp = this.startTime;
        this.changeView(30, 6, 3);
        this.scaleLength = 6 * 60 * 60 * 1000;
        // console.log(this.getSecWidth);
        return;
      }
      if (type <= 3) {
        this.scale = 100;
        this.handleStartTimeByMax(3);
        this.changeView(36, 2.5, 3);
        this.scaleLength = 3 * 60 * 60 * 1000;
      }
    },
  },
  methods: {
    checkClick(val) {
      console.log(val, "====checkCLick");
      // let h = val.substring(0, 2);
      // let m = val.substring(3, 5);
      // let s = val.substring(6, 8);
      // let data = this.mData[0][0];
      // let newTime = s * 1000 + m * 60 * 1000 + h * 60 * 60 * 1000;
      // const _startTime = new Date(DayJs(data.StartTime).format("YYYY-MM-DD"));
      // if (!val) {
      //   return;
      // }

      // // }
      // let _obj = {
      //   StartTime: newTime + _startTime.getTime() - 8 * 60 * 60 * 1000,
      //   EndTime: this.handleTimeNumber(data.EndTime),
      //   cameraName: data.cameraName,
      //   cameraCode: data.cameraCode,
      //   wnd: 1,
      // };
      // this.$emit("handlePlayBackVideo", _obj);
    },
    handleVideoProgress(key) {
      console.log(key, this.getSecWidth, this.progressObject, "===processkey");
      return this.progressObject[key] !== ""
        ? (this.handleTimeNumber(this.progressObject[key]) - this.timestamp) *
            this.getSecWidth
        : 0;
    },
    formatTooltip(val) {
      // console.info('时段信息>>>>>', val);
      if (val >= 0 && val < 25) {
        return "24" + this.$t("date.hours");
      }
      if (val >= 25 && val < 50) {
        return "12" + this.$t("date.hours");
      }
      if (val >= 50 && val < 75) {
        return "9" + this.$t("date.hours");
      }
      if (val >= 75 && val < 100) {
        return "6" + this.$t("date.hours");
      }
      if (val <= 100) {
        return "3" + this.$t("date.hours");
      }
    },
    // 刻度格式展示
    formatScaleTime(val) {
      const time =
        this.timestamp + val * this.interval * this.scaleUn * 60 * 1000;
      return DayJs(time).format("HH:mm") === "00:00"
        ? DayJs(time).format("YYYY-MM-DD")
        : DayJs(time).format("HH:mm");
    },
    // 格式化日期
    /**
     * 当前刻度*2*this.scaleUn*分钟
     */
    formatDate(val) {
      const time =
        this.timestamp + val * this.interval * this.scaleUn * 60 * 1000;
      console.log(
        this.timestamp,
        val,
        this.interval,
        this.scaleUn,
        time,
        "===this.timestamp"
      );
      return DayJs(time).format("YYYY-MM-DD");
    },
    // 改变刻度视图信息
    /**
     * scaleNumber 总刻度数量
     * scaleUn 间隔：分钟
     * interval 每个大刻度中存在几个小刻度
     * scaleNumber * 2 * scaleUn / 60 = 总小时数
     */
    changeView(scaleNumber, scaleUn, interval) {
      this.scaleNum = scaleNumber;
      this.scaleUn = scaleUn;
      this.labelInterVal = interval;
    },
    // 放大视图
    handleChangeViewPlus() {
      if (this.scale === 75 || this.scale === 100) {
        this.scale = 100;
        return;
      }
      this.scale += 25;
    },
    handleChangeView(val) {
      // console.info('拖动的进度信息', val);
      if (val > 0 && val <= 25) {
        console.info("第一时段", this.scale);
        this.scale = 0;
        return;
      }
      if (val > 25 && val <= 50) {
        this.scale = 33.33;
        console.info("第二时段", this.scale);
        return;
      }
      if (val > 50 && val <= 75) {
        this.scale = 66.66;
        console.info("第三时段", this.scale);
        return;
      }
      if (val > 75 && val <= 100) {
        this.scale = 100;
        console.info("第四时段", this.scale);
      }
    },
    // 缩小视图
    handleChangeViewMin() {
      if (this.scale === 25 || this.scale === 0) {
        this.scale = 0;
        return;
      }
      if (this.scale === 100) {
        this.scale -= 25;
        return;
      }
      this.scale -= 25;
    },
    handleStartTimestamp(val) {},
    handleStartTimeByMax(type) {
      if (type === 24) {
        this.handleMaxView();
        return;
      }
      if (type === 3) {
        this.handleMinView();
        return;
      }
      if (type === 12) {
        this.handleLargeView();
      }
    },
    handleMaxView() {
      const _Hour = Number(this.getStartTimeM);
      const _Min = Number(this.getStartTimeS);
      if (_Hour % 6 === 0) {
        this.timestamp = this.startTime;
        return;
      }
      if (_Hour > 0 && _Hour < 6) {
        this.timestamp =
          this.startTime - _Hour * 60 * 60 * 1000 - _Min * 60 * 1000;
        return;
      }
      if (_Hour > 6 && _Hour < 12) {
        this.timestamp =
          this.startTime - (_Hour - 6) * 60 * 60 * 1000 - _Min * 60 * 1000;
        return;
      }
      if (_Hour > 12 && _Hour < 18) {
        this.timestamp =
          this.startTime - (_Hour - 12) * 60 * 60 * 1000 - _Min * 60 * 1000;
        return;
      }
      if (_Hour > 18) {
        this.timestamp =
          this.startTime - (_Hour - 18) * 60 * 60 * 1000 - _Min * 60 * 1000;
      }
    },
    handleMinView() {
      let _Min = this.getStartTimeS;
      if (Number(_Min) % 5 === 0) {
        this.timestamp = this.startTime;
        return;
      }
      if (Number(_Min) > 10) {
        // const _m = Number(_Min.substring(0, 1));
        const _s = Number(_Min.substring(1, 2));
        if (_s > 5) {
          this.timestamp = this.startTime - (_s - 5) * 60 * 1000;
          return;
        }
        if (Number(_s) < 5) {
          this.timestamp = this.startTime - _s * 60 * 1000;
          return;
        }
        return;
      }
      if (Number(_Min) > 5) {
        this.timestamp = this.startTime - (Number(_Min) - 5) * 60 * 1000;
        return;
      }
      this.timestamp = this.startTime - Number(_Min) * 60 * 1000;
    },
    handleLargeView() {
      let _Min = Number(this.getStartTimeS);
      if (_Min % 30 === 0) {
        this.timestamp = this.startTime;
      }
    },
    handleTimeNumber(val) {
      console.log(val, "====valhandletimenumber");
      // let yearStr = val.substring(0, 4);
      // let monthStr = val.substring(4, 6);
      // let dayStr = val.substring(6, 8);
      // let hhStr = val.substring(8, 10);
      // let mmStr = val.substring(10, 12);
      // let ssStr = val.substring(12, 14);
      // let _tmpStr =
      //   yearStr +
      //   "/" +
      //   monthStr +
      //   "/" +
      //   dayStr +
      //   " " +
      //   hhStr +
      //   ":" +
      //   mmStr +
      //   ":" +
      //   ssStr;
      // return new Date(_tmpStr).getTime();
      // return new Date(_tmpStr).getTime() + Math.abs(this.localOffset)
    },
    hasClass(start, end) {
      // console.log('start,end', start + '-', end);
      const _s = this.handleTimeNumber(start);
      const _e = this.handleTimeNumber(end);
      const _left = (_s - this.startTime) * this.getSecWidth;
      const _width = (_e - _s) * this.getSecWidth;
      return { left: _left + "px", width: _width + "px" };
    },
    hasTypeClass(type) {
      return type === "010" ? "green" : type === "100" ? "" : "green";
    },
    handleClickActive(val) {
      this.activeWindow = val;
      this.$emit("handleSetActiveWnd", val);
    },
    handleMouseHover(e, key) {
      console.log(e, this.getLeft, "====mousehover");
      if (this.activeWindow !== key) {
        return;
      }
      this.cursorOpacity = 1;
      this.cursorLeft = e.clientX - this.getLeft + 15;
      // 此处的743是以当前点距窗口left的标准宽度
      // this.cursorValue = e.clientX - this.getLeft - 32 - 135
      e.clientX - 743 > 0
        ? (this.cursorValue = e.clientX - 743)
        : (this.cursorValue = 0);
    },
    handleMouseLeave() {
      this.cursorOpacity = 0;
    },
    handleClickPlay(e, key, item) {
      console.log(e, item, this.endTime, "====e");
      // 快进
      this.$log.debug("handleClickPlay", e);
      if (this.activeWindow !== key) {
        return;
      }
      const _start =
        this.timestamp + (e.clientX - this.getLeft - 167) / this.getSecWidth;
      const _startTime = DayJs(_start).format("YYYY-MM-DD HH:mm:ss");
      const _obj = {
        startTime: Math.round(_start),
        endTime: this.endTime,
        deviceObj: item,
        wnd: key,
      };
      console.log(_obj, "====obj");
      // let divDom=document,getElementsByClassName('')
      this.$emit("handlePlayBackSingleVideo", _obj);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/ioc/pages/common.scss";

.soc_back_videos {
  // height: 215px;
  width: 100%;
  // background-color: #1A2137;
  margin-top: 4px;
  border-top: #394567 solid 1px;
  position: relative;
  display: flex;
  flex-direction: column;

  .back_mark {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 98;
    background-color: rgba(#000, 0.2);
    left: 0;
    top: 0;
  }

  .video_cursor {
    position: absolute;
    width: 1px;
    height: 215px;
    background-color: #66d1b5;
    z-index: 98;
    top: 0;
    left: 0;

    .video_cursor_content {
      width: 100%;
      height: 100%;
      position: relative;

      .time_format {
        width: 75px;
        position: fixed;
        z-index: 1;
        margin-left: -37px;
        margin-top: -15px;
        background-color: rgba(#000, 0.3);
        color: #fff;
        white-space: nowrap;
        font-size: 12px;
        text-align: center;
      }
    }
  }

  .list_content_container {
    flex: 1;
    overflow-y: auto;
    scrollbar-arrow-color: $soc-color-background; /**/ /*三角箭头的颜色*/
    scrollbar-face-color: $soc-color-background; /**/ /*立体滚动条的颜色*/
    scrollbar-3dlight-color: #1a2137; /**/ /*立体滚动条亮边的颜色*/
    scrollbar-highlight-color: #1a2137; /**/ /*滚动条空白部分的颜色*/
    scrollbar-shadow-color: #1a2137; /**/ /*立体滚动条阴影的颜色*/
    scrollbar-darkshadow-color: #1a2137; /**/ /*立体滚动条强阴影的颜色*/
    scrollbar-track-color: #1a2137; /**/ /*立体滚动条背景颜色*/
    scrollbar-base-color: #1a2137; /**/ /*滚动条的基本颜色*/
  }

  .back_camera_item {
    height: 30px;
    border-bottom: #272e42 solid 1px;
    display: flex;
    flex-direction: row;
    align-items: center;

    &.active {
      // background-color: #66d1b5;

      background-color: $soc-color-background;

      .camera_back_data {
        .down_load_icon {
          opacity: 1;
        }

        .data_content {
          .cursor_div {
            opacity: 1;
          }

          .video_data_list {
            opacity: 1;
          }
        }
      }
    }

    &.download {
      background-color: transparent !important;

      .camera_back_data {
        .down_load_icon {
          opacity: 0.2 !important;
        }

        .data_content {
          .cursor_div {
            opacity: 0.2 !important;
          }

          .video_data_list {
            opacity: 0.2 !important;
          }
        }
      }
    }

    .camera_title {
      width: 135px;
      border-right: rgba(#586583, 0.5) solid 1px;
      height: 100%;
      font-size: 12px;
      color: $soc-font-color;
      /*overflow: hidden;*/
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 30px;
      padding: 0 7px 0 16px;

      &.noresize {
        overflow: hidden;
      }

      &.nor {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0;

        i {
          margin: 0 7px;
          cursor: pointer;
        }
      }
    }

    .camera_back_data {
      flex: 1;
      height: 100%;
      padding: 0 48px 0 32px;
      position: relative;

      .download_container {
        width: 100px;
        position: absolute;
        z-index: 99;
        height: 20px;
        top: 5px;
        background-color: $soc-primary-color;

        .download_content {
          width: 100%;
          height: 100%;
          position: relative;

          .download_content_left_cur {
            position: absolute;
            width: 6px;
            height: 100%;
            top: 0;
            left: -8px;
            background-color: #d8d8d8;
            border-bottom-left-radius: 8px;
            border-top-left-radius: 8px;
            z-index: 1;
            cursor: pointer;

            &:hover::before {
              content: attr(data-title); //取到data-title属性的值
              display: inline-block;
              border: 1px solid #313a5b;
              background: #313a5b;
              text-align: center;
              border-radius: 2px;
              padding: 2px 3px;
              position: fixed;
              font-size: 12px;
              height: 20px;
              z-index: 33;
              line-height: 20px;
              margin-left: -20px;
              margin-top: -30px;
              color: #fff;
              white-space: nowrap;
            }
          }

          .download_content_right_cur {
            position: absolute;
            width: 6px;
            height: 100%;
            top: 0;
            right: -8px;
            background-color: #d8d8d8;
            border-bottom-right-radius: 8px;
            border-top-right-radius: 8px;
            z-index: 1;
            cursor: pointer;

            &:hover::before {
              content: attr(data-title); //取到data-title属性的值
              display: inline-block;
              border: 1px solid #313a5b;
              background: #313a5b;
              text-align: center;
              border-radius: 2px;
              padding: 2px 3px;
              position: fixed;
              font-size: 12px;
              height: 20px;
              line-height: 20px;
              margin-left: -20px;
              margin-top: -30px;
              z-index: 2;
              color: #fff;
              white-space: nowrap;
            }
          }

          .download_btn {
            position: fixed;
            margin-top: 28px;
            margin-left: -30px;
            z-index: 1;
            width: 138px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            &.bottom {
              margin-top: -38px;
            }
          }
        }
      }

      .down_load_icon {
        position: absolute;
        height: 100%;
        right: 10px;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        opacity: 0;
        cursor: pointer;

        i {
          color: $soc-font-color;
          font-size: 20px;

          &:hover {
            color: $soc-primary-color;
          }
        }
      }

      .data_content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
        overflow: hidden;

        .cursor_div {
          width: 11px;
          height: 12px;
          position: absolute;
          left: 0;
          top: 5px;
          z-index: 9;
          opacity: 0.2;

          .svg-cursor {
            width: 11px !important;
            height: 12px !important;
            vertical-align: 0em !important;
          }

          .cursor_div_content {
            width: 100%;
            height: 100%;
            /*background-color: #000;*/
            position: relative;
            box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
            padding: 0;

            em {
              display: block;
              border-width: 5px;
              position: absolute;
              top: 10px;
              left: 0;
              border-style: solid dashed dashed;
              border-color: #fff transparent transparent;
              font-size: 0;
              line-height: 0;
              z-index: 99;
            }
          }
        }

        .video_data_list {
          background-color: $soc-primary-color;
          position: absolute;
          width: auto;
          left: 0;
          top: 5px;
          z-index: 2;
          height: 20px;
          opacity: 0.2;
          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.12);

          &.green {
            background-color: #66d1b5;
            z-index: 1;
          }

          &.red {
            background-color: #e6625e;
            z-index: 3;
          }
        }
      }

      .scale_container {
        width: 100%;
        display: flex;
        flex-direction: row;

        .scale_un {
          position: relative;

          &:first-child {
            &::before {
              content: "";
              height: 10px;
              width: 1px;
              background: #586583;
              position: absolute;
            }

            .label {
              position: absolute;
              width: 70px;
              z-index: 1;
              top: 14px;
              left: -30px;
              font-size: 10px;
              color: $soc-font-color;
              -webkit-transform: scale(0.84);
            }
          }

          &.ps {
            height: 7px;

            .label {
              position: absolute;
              z-index: 1;
              width: 30px;
              top: 14px;
              right: -15px;
              font-size: 10px !important;
              color: $soc-font-color;
              -webkit-transform: scale(0.84);
              text-align: center;
              white-space: nowrap;
            }
          }

          flex: 1;
          border-right: #586583 solid 1px;
          height: 3px;
        }
      }
    }
  }
}
</style>
